(() => {
  if (!customElements.get("image-gallery")) {
    class t extends HTMLElement {
      constructor() {
        super(), this.mediaSlides = this.querySelectorAll("[data-media-index]"), this.triggerElements = this.querySelectorAll("[data-trigger-index]"), 
        this.links = this.querySelectorAll("[data-link-index]"), this.cta = this.querySelector("[data-cta]"), 
        this.urls = JSON.parse(this.querySelector('script[type="application/json"]').textContent), 
        this.observer = new IntersectionObserver(this.handleIntersection.bind(this), {
          threshold: .5
        }), this.init();
      }
      init() {
        this.triggerElements.forEach(t => {
          this.observer.observe(t);
        }), this.links.forEach((t, e) => {
          t.addEventListener("click", t => {
            t.preventDefault(), this.triggerElements[e].scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          });
        });
      }
      handleIntersection(t) {
        t.forEach(t => {
          if (t.isIntersecting) {
            const e = t.target.dataset.triggerIndex;
            this.updateActiveSlide(e);
          }
        });
      }
      updateActiveSlide(t) {
        this.mediaSlides.forEach(e => {
          const s = e.dataset.mediaIndex === t;
          e.classList.toggle("opacity-100", s), e.classList.toggle("opacity-0", !s);
        }), this.links.forEach(e => {
          const s = e.dataset.linkIndex === t;
          e.classList.toggle("opacity-100", s), e.classList.toggle("underline", s), e.classList.toggle("opacity-60", !s);
        }), this.cta && this.urls[t] && (this.cta.href = this.urls[t]);
      }
    }
    customElements.define("image-gallery", t);
  }
})();